import FetchClient, { type ApiResponse } from "./FetchClient";

export interface CrawlerSchedule {
  retailer: string;
  schedule: number[];
}

export async function getCrawlerSchedules(): Promise<CrawlerSchedule[]> {
  const response = await FetchClient.get<ApiResponse<CrawlerSchedule[]>>("/admin/crawler-schedules");
  return response.data ?? [];
}

export async function putCrawlerSchedule(retailer: string, schedule: number[]): Promise<CrawlerSchedule> {
  const response = await FetchClient.put<ApiResponse<CrawlerSchedule>>("/admin/crawler-schedules", { retailer, schedule });
  return response.data;
}
